<template>

<div class="game_grWrap"> 
        <!-- 游戏积分与规则 -->
        <div class="gameMenu" >
            <div class="gameLoadbox">
                <img src="../assets/images/gameProgress_liheicon.png" class="loadimg">
                <div class="progressBox">
                    <div class="gameProgress">
                      <div class="gameProgressNow"></div>
                    </div>
                    <p>{{getProgress}}%</p>
                </div>   
               
            </div>
        </div>
        <!-- 游戏积分与规则 -->

        <div class="page-wrapper">
          <button id="addtocart">
            <span class="cart-item"></span>
          </button>
        </div>

</div>

</template>

<script type="text/javascript">

$(document).ready(function(){
  // $('#addtocart').on('click',function(){
  //   var button = $(this);
  //   var cart = $('#cart');
  //   var cartTotal = cart.attr('data-totalitems');
  //   var newCartTotal = parseInt(cartTotal) + 1;
   
  //   $('#addtocart').addClass('sendtocart');
  //   setTimeout(function(){
  //      $('#addtocart').removeClass('sendtocart');
  //   },1000)
  // })
 /* function setAnimate(){
                        var button = $(this);
                        var cart = $('#cart');
                        var cartTotal = cart.attr('data-totalitems');
                        var newCartTotal = parseInt(cartTotal) + 1;
                        button.addClass('sendtocart');
                        setTimeout(function(){
                          button.removeClass('sendtocart');
                          $('#cart').addClass('shake').attr('data-totalitems', newCartTotal);
                   
                        },1000)
  }*/
})


    export default{
        name:'gameProgress',
        props:['getProgress'],
        data(){
            return {
            }
        },
        mounted (){
        },
        methods:{
              menuChecker(type,isCutSwiper){
                this.$emit('menuChecker',type,isCutSwiper);
              }
        }
    }
</script>


<style type="text/css">


*, *:before, *:after {
  box-sizing: border-box;
}

.page-wrapper { pointer-events: none; 
  min-height: 100%;    position: fixed;
    z-index: 99999999;
    top: 0px;width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-wrapper button {
  padding: 20px;
  border: none;
  background: transparent;
  position: relative;
  outline: none;
  border-radius: 5px;
  color: #292d48;
  font-size: 18px;
}
.page-wrapper button .cart-item {
  position: absolute;
  height: 24px;
  width: 24px;
  top: -10px;
  left: -10px;
}
.page-wrapper button .cart-item:before {
  content: '+20%';
  display: block;
  line-height: 24px;
  height: 24px;
  width: .8rem;
  font-size: 12px;
  font-weight: 600;
  background: transparent;
  color: #ffe2c1;
  border-radius: 20px;
  text-align: center; opacity: 0;
}
.page-wrapper button.sendtocart .cart-item {    color: #ffca89;
  display: block;
  animation: xAxis .5s forwards cubic-bezier(1, 0.44, 0.84, 0.165);
}
.page-wrapper button.sendtocart .cart-item:before {
  animation: yAxis .5s alternate forwards cubic-bezier(0.165, 0.84, 0.44, 1);
}

.cart {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: #292d48;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.cart i {
  font-size: 25px;
  color: white;
}
.cart:before {
  content: attr(data-totalitems);
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  top: -12px;
  right: -12px;
  background: #2bd156;
  line-height: 24px;
  padding: 0 5px;
  height: 24px;
  min-width: 24px;
  color: white;
  text-align: center;
  border-radius: 24px;
}
.cart.shake {
  animation: shakeCart .4s ease-in-out forwards;
}

@keyframes xAxis {
  0% {
    opacity: 1;
  }
  100% {
    transform: translateX(calc(50vw - 75px));opacity: 1;
  }
}
@keyframes yAxis {
  0% {
    opacity: 1;
  }
  100% {
    transform: translateY(calc(-50vh + 78px));opacity: 1;
  }
}
@keyframes shakeCart {
  25% {
    transform: translateX(6px);
  }
  50% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(2px);
  }
  100% {
    transform: translateX(0);
  }
}




.gameMenu{    /* width: 7.5rem; */
    height: 1.45rem;
    position: fixed;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    top: 32px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    left: 50%;
    margin-left: -3.8rem;}
    .gameLoadbox{    /* background-color: rgba(0, 0, 0, 0.65); */
    width: 90%;
    background: url(../assets/images/gameProgress_bj.png);
    margin: 0.05rem auto;
    height: 14.75rem;
    /* display: -webkit-box; */
    background-size: cover;
    display: -ms-flexbox;
    display: flex;
    /* border-radius: 62px; */
    transform: scale(0.6);
    -webkit-transform: scale(0.6);}
    .loadimg{           width: 1.46rem;
    height: 1.06rem;
    position: absolute;
    top: -0.32rem;
    left: 0.5rem;    z-index: 9999;
    }
    .progressBox{         background-color: transparent;
    width: 82%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    top: 0.32rem;
    left: 1.65rem;}
    .btnMenu{        width: 1.15rem;
    height: 1.16rem;
    margin-top: -0.05rem;}
    .gameProgress{       width: 70%;
    height: 0.145rem;
    border-radius: 1rem;}
    .gameProgressNow{    width: 1%;border: solid 0.01rem #e6b273;
    height: 100%;
    border-radius: 1rem;
    background-color: #b08d65;}
    .progressBox p{    margin-left: 0.1rem;
    color: #ffca89;}

.siblingsMenubox{background-color: rgba(93, 34, 0, 0.7);
    width: 80%;
    margin: -0.2rem auto; position: relative;
    /* height: 2rem; */
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 12px;
    color: #fff;
    font-size: 0.28rem;
    padding: 0.15rem 0;}
    .siblingsMenubox ul li{      float: left;
    width: 33%;
    text-align: center;
    line-height: 0.6rem;}
    .siblingsMenubox p{     width: 100%;
    border-bottom: 0.01rem solid #f7d1bd;
    position: absolute;
    top: 45%;
    left: 0px;
    height: 0.1rem;
    z-index: 999; }
    .gameproRuler{    width: 25%;
    background-color: #cacaca;
    border-top-right-radius: 1.3rem;
    border-bottom-right-radius: 1.3rem;
    color: #db4542;
    display: flex;
    justify-content: center;
    align-items: center;}
    .gameproRuler svg{width: 0.4rem;height: 0.4rem;}
    .gameproRuler span{ padding-left: 0.05rem; font-size: 0.32rem;font-weight: blod }

    @media screen and (max-width: 450px) {
        .gameMenu {
            left: 0;
            margin-left: 0rem;
        }
        .gameMenu{width: 100%;}
        .gameLoadbox{transform: scale(1); -webkit-transform: scale(1);}
    } 
</style>



// WEBPACK FOOTER //
// src/components/gameProgress.vue